import { computed, openBlock, createElementBlock, normalizeStyle, renderSlot } from "vue";
/* empty css               */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 1,
  class: "avatar-string"
};
const _sfc_main = {
  __name: "Avatar",
  props: {
    src: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 32
    }
  },
  setup(__props) {
    const props = __props;
    const avatarStyle = computed(() => ({
      width: props.size + "px",
      height: props.size + "px",
      lineHeight: props.size - 4 + "px",
      fontSize: props.size / 2 + "px"
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "avatar",
        style: normalizeStyle(avatarStyle.value)
      }, [
        __props.src ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: __props.src,
          alt: "avatar image",
          class: "avatar-image"
        }, null, 8, _hoisted_1)) : (openBlock(), createElementBlock("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]))
      ], 4);
    };
  }
};
const Avatar = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ee7c0702"]]);
export {
  Avatar as default
};
//# sourceMappingURL=Avatar.vue.es.js.map
